module.exports = __webpack_public_path__ + "img/schnittkante_oekograu_restpaste.cd99a4a9.jpg";